<template>
  <div>
    <vue-data-table
      :headers="headers"
      :data="rows"
      :items-per-page="15"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :show-filter="false"
      :sync-with-url="false"
      :table-actions="tableActions"
    >
      <template #cell-customerFullName="{ row }">
        <span v-if="row.payment && row.payment.customer">
          {{ row.payment.customer.fullName }}
          {{ row.payment.customer.society }}
        </span>
        <span v-else class="text-muted">—</span>
      </template>

      <template #cell-repairRef="{ row }">
        <span class="fw-semibold">{{ row.repair_reference }}</span>
      </template>

      <template #cell-paymentMethod="{ row }">
        <span v-if="row.payment" class="text-primary">{{
          row.payment.paymentMethod
        }}</span>
      </template>

      <template #cell-amount="{ row }">
        <span class="text-success fw-bold">{{ formatMoney(row.amount) }}</span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: "reference", label: "Ref. ligne", class: "" },
        { field: "repairRef", label: "Reparation", class: "" },
        { field: "customerFullName", label: "Client", class: "" },
        { field: "date", label: "Date", class: "" },
        { field: "paymentMethod", label: "Mode", class: "" },
        { field: "amount", label: "Montant", class: "text-success" },
        { field: "remark", label: "Remarque", class: "" },
      ],
      summableColumns: [{ field: "amount", class: "text-success" }],
      buttons: [
        {
          label: "Details",
          icon: "bi bi-info-square",
          class: "btn btn-outline-primary",
          action: (row) =>
            this.$router.push({
              name: "payments-repairs-details",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Modifier",
          icon: "bi bi-pencil-square",
          class: "btn btn-outline-secondary",
          action: (row) =>
            this.$router.push({
              name: "payments-repairs-edit",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-outline-danger",
          action: (row) => this.remove(row),
        },
      ],
      tableActions: [
        {
          title: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => this.refresh(),
        },
        {
          title: "Nouveau paiement",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () =>
            this.$router.push({ name: "payments-repairs-create" }),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("paymentRepair", {
      rows: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("paymentRepair/fetchAll");
  },
  methods: {
    formatMoney(v) {
      if (v == null || v === "") return "—";
      return parseFloat(v).toFixed(2) + " DH";
    },
    refresh() {
      this.$store.dispatch("paymentRepair/fetchAll");
    },
    remove(row) {
      this.$confirm({
        message:
          "Supprimer ce paiement pour la reparation " +
          row.repair_reference +
          " ?",
        button: { no: "Non", yes: "Oui" },
        callback: (ok) => {
          if (ok) {
            this.$store.dispatch("paymentRepair/destroy", row.reference);
          }
        },
      });
    },
  },
};
</script>
